import { computed } from 'vue'

import { EventTypeEnum } from '@/gql/myomr'

type EventFormConfig = {
  editStreamingKey: boolean
  editVideo: boolean
}

const defaultEventFormConfig: EventFormConfig = {
  editStreamingKey: false,
  editVideo: false,
}

const eventFormConfigs: { [key in EventTypeEnum]?: EventFormConfig } = {
  [EventTypeEnum.Masterclass]: {
    editStreamingKey: true,
    editVideo: false,
  },
  [EventTypeEnum.DigitalMasterclass]: {
    editStreamingKey: false,
    editVideo: true,
  },
}

const useEventFormConfig = (type?: EventTypeEnum | null) =>
  computed<EventFormConfig>(() => (type && eventFormConfigs[type]) || defaultEventFormConfig)
export default useEventFormConfig
